module.exports = "\n<div style=\"height:46px\" class=\"lane status-mts\">\n</div>\n<div class='video-container' >\n    <br>\n    <br>\n    <br>\n    <br>\n<video *ngIf=\"initPlayer\" id=\"player\" class=\"video-js\" style=\"padding-top: 80px; margin:auto; background-color:white\" controls preload=\"auto\"  [attr.poster]=\"getEnvironment().mediawbposter\"  data-setup=\"{}\"></video>\n</div>\n\t\t"


//////////////////
// WEBPACK FOOTER
// /app/src/app/wb/media/media-wb.component.html
// module id = ../../../../../src/app/wb/media/media-wb.component.html
// module chunks = main